<template>
	<div>
		<b-button type="is-primary" class="max-w-button highly-button" @click="$router.push({ name: 'news-new' })">
			<div class="horizontal-center-center button-icon-right">
				<span>ニュースを作成する</span><img :src="require('@/assets/icons/news_edit.svg')">
			</div>
		</b-button>

		<ul class="tabs mt-30" ref="tabs">
			<li v-for="(row, index) in news" :key="row.tab.id" :style="{ 'background': row.tab.color }" @click="onTabClick(index)">{{ row.tab.name }}</li>
		</ul>

		<div class="news-list-wrap">
			<div class="news-list" v-show="index === currentTabIndex" v-for="(row, index) in news" :key="row.tab.id" :style="{ 'background': row.tab.color }">
				<div v-if="row.list.length > 0">
					<news-summary v-for="(row, index) in row.list" :key="index" :data="row" @click="onNewsClick" @edit-click="onEditClick" @delete-click="onDeleteClick"></news-summary>

				</div>

				<div v-else>
					ニュースはありません
				</div>

				<split-loader class="mt-10" :key="index" :index="index" :current="currentTabIndex" :windowH="windowH" :isLoading="isSplitLoading" @base-touch="onBaseTouch"></split-loader>
			</div>
		</div>


		<b-modal :active.sync="isDeleteConfirmModalActive">
			<confirm-modal title="削除確認" body="記事を削除します。よろしいですか？" okButtonTitle="削除する" @ok-click="onDeleteConfirmModalOkClick" @cancel-click="isDeleteConfirmModalActive = false"></confirm-modal>
		</b-modal>
	</div>
</template>

<style lang="scss" scoped>
@import '@/scss/_vars.scss';

.news-list {
	padding: 20px 10px;
	cursor: pointer;
	min-height: calc(100vh - 178px);
}

.news-list-wrap,
.tabs {
	margin-left: -$basePadding;
	margin-right: -$basePadding;
	margin-bottom: -50px;
}

.tabs {
	margin-bottom: 0;
	li {
		display: block;
		padding: 5px 0;
		min-width: 220px;
		text-align: center;
		font-size: 18px;
		font-weight: $extraBold;
		border-radius: 10px 10px 0 0;

		&:not(first-child) {
			margin-left: 1px;
		}
	}
}

@media screen and (min-width: $breakPoint) {
	.news-list {
		padding-left: 200px;
		padding-right: 200px;

		/deep/ .news-preview {
			text-align: left;
		}
	}
}
</style>

<script>
import NewsSummary from '@/components/NewsSummary'
import ConfirmModal from '@/components/ConfirmModal'
import SplitLoader from '@/components/SplitLoader'

export default {
	name: 'News',
	components: {
		NewsSummary,
		ConfirmModal,
		SplitLoader,
	},
	data () {
		return {
			currentTabIndex: 0,
			news: [],
			isDeleteConfirmModalActive: false,
			deleteId : '',
			isSplitLoading: false,
			windowH: 0,
			currentTabScrollLeft: 0,
		}
	},
	created() {
	},
	mounted() {
		this.init();
		//this.$refs.tabs.addEventListener('scroll', this.onTabScroll);
		this.$refs.tabs.addEventListener('scroll', (e) => this.currentTabScrollLeft = e.target.scrollLeft);
		//this.$refs.tabs.addEventListener('scroll', (e) => console.log(e.target.scrollLeft));
		this.windowH = document.getElementsByTagName('html')[0].clientHeight;
	},
	methods: {
		onBaseTouch: async function(index) {
			this.$utils.log('onBottomTouch');
			if (this.news[index].last_id === '') {
				return;
			}
			this.isSplitLoading = true;

			let ep = `news/category/${this.news[index].tab.id}/${this.news[index].last_id}`;
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.news[index].last_id = res.data.last_id;
				let tmp = this.news[index].list.concat(res.data.list);
				this.news[index].list = tmp;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isSplitLoading = false;
			}
		},
		onTabScroll: function(e) {
			//this.$utils.log(e.target);
			this.currentTabScrollLeft = e.target.scrollLeft;
		},
		onDeleteConfirmModalOkClick: async function() {
			this.isDeleteConfirmModalActive = false;

			let ep = 'news/' + this.deleteId;
			this.$utils.log(ep);

			try {
				let res = await this.$api.delete(ep, null, true);
				this.$utils.log(res);
				for (let i in this.news) {
					for (let k in this.news[i].list) {
						if (this.news[i].list[k].id === this.deleteId) {
							this.news[i].list.splice(k, 1);
						}
					}
				}
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isDraftLoading = false;
			}
		},
		onEditClick: function(id) {
			this.$router.push({ name: 'news-edit', params: { newsId: id }});
		},
		onDeleteClick: function(id) {
			this.deleteId = id;
			this.isDeleteConfirmModalActive = true;
		},
		onNewsClick: function(id) {
			this.storeState();
			this.$router.push({ name: 'news-view', params: { newsId: id, token: this.$consts.DUMMY_TOKEN }});
		},
		storeState: function() {
			this.$utils.log('storeState');
			this.$store.commit('basic', {
				key: 'isCurrentNewsStateStored',
				value: true,
			});
			this.$store.commit('basic', {
				key: 'currentNews',
				value: this.news,
			});
			this.$store.commit('basic', {
				key: 'currentNewsTabIndex',
				value: this.currentTabIndex,
			});
			this.$store.commit('basic', {
				key: 'currentNewsTabScrollLeft',
				value: this.currentTabScrollLeft,
			});
		},
		onTabClick: function(index) {
			this.currentTabIndex = index;
		},
		init: function() {
			if (this.$store.state.isCurrentNewsStateStored) {
				this.news = this.$store.state.currentNews;

				this.$nextTick(function() {
					this.currentTabIndex = this.$store.state.currentNewsTabIndex;
					this.$refs.tabs.scrollLeft = this.$store.state.currentNewsTabScrollLeft;
				});
			} else {
				this.getData();
			}
		},
		getData: async function() {
			let loader = this.$buefy.loading.open();
			let ep = 'news';
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.news = res.data;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loader.close();
			}
		},
	}
}
</script>
